import React from 'react';
import { formatCurrencyAbbrev, formatCurrency } from '../../utils/invoiceFormatters';

const CARDS = [
  { key: 'totalBilled',        label: 'Total Billed',      color: '#1F2937' },
  { key: 'totalMakerCharge',   label: 'Maker Charges',     color: '#0C447C' },
  { key: 'totalLoadingCharge', label: 'Loading Charges',   color: '#085041' },
  { key: 'totalAdminCharge',   label: 'Admin Charges',     color: '#3C3489' },
  { key: 'totalUpiCharge',     label: 'UPI Charges',       color: '#633806' },
];

const SkeletonCard = () => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-5 flex-1 min-w-0">
    <div className="h-3 bg-gray-200 rounded animate-pulse w-24 mb-3" />
    <div className="h-7 bg-gray-200 rounded animate-pulse w-32 mb-2" />
    <div className="h-2.5 bg-gray-100 rounded animate-pulse w-20" />
  </div>
);

const SummaryCards = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="flex gap-4 mb-6">
        {CARDS.map((_, i) => <SkeletonCard key={i} />)}
      </div>
    );
  }

  return (
    <div className="flex gap-4 mb-6 flex-wrap">
      {CARDS.map((card) => {
        const value = data?.[card.key] ?? 0;
        return (
          <div key={card.key}
            className="bg-white rounded-xl border border-gray-100 shadow-sm p-5 flex-1 min-w-[160px]">
            <p className="text-xs text-gray-700 font-bold mb-1">{card.label}</p>
            <p className="text-2xl font-bold" style={{ color: card.color }}>
              {formatCurrencyAbbrev(value)}
            </p>
            <p className="text-xs text-gray-400 mt-1">{formatCurrency(value)}</p>
            {card.key === 'totalBilled' && data && (
              <p className="text-xs text-gray-400 mt-1">
                {data.invoicedCount ?? 0} of {data.totalEnterprises ?? 0} enterprises
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SummaryCards;
